module.exports = __webpack_public_path__ + "static/media/con_spa_ins_che_cct.2e5b424a.png";